var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FFE4E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.50017V9.50017M10 11.5002H10.005M14.309 6.99217C12.7281 7.07613 11.1784 6.52947 10 5.47217C8.82163 6.52947 7.27195 7.07613 5.691 6.99217C5.56377 7.48473 5.49959 7.99144 5.5 8.50017C5.5 11.2957 7.412 13.6452 10 14.3112C12.588 13.6452 14.5 11.2962 14.5 8.50017C14.5 7.97917 14.4335 7.47417 14.309 6.99217Z",
    stroke: "#F43F5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error.dff8ed7c71500454466e2a2406f4db71.svg";